export const productSortingValues = {
  NAME: 'name',
  TYPE: 'type',
  STATUS: 'status',
  LAST_MODIFIED: 'last_modified',
};
